export default __webpack_public_path__ + "static/media/meeting-vector-img.fab9e133.png";